import { TransactionTab } from "@/modules/transaction/common/enum";
import { Transfers } from "@/modules/transaction/components";
import { getTransactionTabItems } from "@/modules/transaction/helpers";
import { EmptyOrErrorContent, PageHeader } from "@/shared/components";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { Tab } from "@ab.uitools/ui-library/components/Tab";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

type ITemplate = {
  [key in TransactionTab]: ReactNode;
};

export const TransactionsPage = () => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState<string>(TransactionTab.Transfers);

  const template: ITemplate = {
    [TransactionTab.Transfers]: <Transfers/>,
    // TODO: temporary solution
    [TransactionTab.Payments]: <div
      className="full-width flexbox align-items--center pt-32 pb-32 empty-content-wrapper">
      <EmptyOrErrorContent
        isShowButton={false}
        title={t("general.comingSoon")}
      />
    </div>,
  };
  return (
    <div className="full-width page-container transactions-page">
      <PageHeader/>
      <div className="full-width flexbox justify-content--center h-fit-content page-body">
        <div className="transactions-wrapper">
          <Heading className="content-title mb-20" size="xsmall" weight="bolder">
            {t("transactions.title")}
          </Heading>
          <div
            className="flexbox justify-content--between align-items--center full-width tabs-section mt-16 mb-32">
            <Tab
              size="small"
              color="light"
              tabItems={getTransactionTabItems({ t })}
              selectedValue={selectedValue}
              onSelect={(value) => setSelectedValue(value as string)}
            />
          </div>
          <div className="full-width">
            {template[selectedValue as TransactionTab]}
          </div>
        </div>
      </div>
    </div>
  );
};
